
/**
 * Lightbox Gallery Frontend Interactivity
 */

document.addEventListener('DOMContentLoaded', function() {
	const galleries = document.querySelectorAll('.wp-block-moldovanos-block-lightbox-gallery');

	galleries.forEach(function(gallery) {
		const items = gallery.querySelectorAll('.wp-block-moldovanos-block-lightbox-gallery__item');
		let currentIndex = 0;
		let lightbox = null;

		function createLightbox() {
			if (lightbox) {
				return;
			}

			lightbox = document.createElement('div');
			lightbox.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox';

			const content = document.createElement('div');
			content.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-content';

			// Header with close button
			const header = document.createElement('div');
			header.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-header';

			const closeBtn = document.createElement('button');
			closeBtn.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-close';
			closeBtn.innerHTML = '×';
			closeBtn.setAttribute('aria-label', 'Close lightbox');

			// Image wrapper with nav buttons
			const imageWrapper = document.createElement('div');
			imageWrapper.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-image-wrapper';

			const prevBtn = document.createElement('button');
			prevBtn.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-nav wp-block-moldovanos-block-lightbox-gallery__lightbox-nav--prev';
			prevBtn.innerHTML = '←';
			prevBtn.setAttribute('aria-label', 'Previous image');

			const img = document.createElement('img');
			img.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-image';

			const nextBtn = document.createElement('button');
			nextBtn.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-nav wp-block-moldovanos-block-lightbox-gallery__lightbox-nav--next';
			nextBtn.innerHTML = '→';
			nextBtn.setAttribute('aria-label', 'Next image');

			// Caption
			const caption = document.createElement('div');
			caption.className = 'wp-block-moldovanos-block-lightbox-gallery__lightbox-caption';

			// Assemble structure
			header.appendChild(closeBtn);
			imageWrapper.appendChild(prevBtn);
			imageWrapper.appendChild(img);
			imageWrapper.appendChild(nextBtn);
			content.appendChild(header);
			content.appendChild(imageWrapper);
			content.appendChild(caption);
			lightbox.appendChild(content);
			document.body.appendChild(lightbox);

			// Event listeners
			closeBtn.addEventListener('click', closeLightbox);
			prevBtn.addEventListener('click', showPrevImage);
			nextBtn.addEventListener('click', showNextImage);
			lightbox.addEventListener('click', function(e) {
				if (e.target === lightbox) {
					closeLightbox();
				}
			});

			document.addEventListener('keydown', handleKeyPress);

			img.addEventListener('contextmenu', function(e) {
				e.preventDefault();
			});
		}

		function openLightbox(index) {
			createLightbox();
			currentIndex = index;
			updateLightboxImage();
			document.body.style.overflow = 'hidden';
			setTimeout(function() {
				lightbox.classList.add('is-open');
			}, 10);
		}

		function closeLightbox() {
			if (!lightbox) {
				return;
			}
			lightbox.classList.remove('is-open');
			document.body.style.overflow = '';
			setTimeout(function() {
				if (lightbox && lightbox.parentNode) {
					lightbox.parentNode.removeChild(lightbox);
					lightbox = null;
				}
			}, 300);
		}

		function showPrevImage() {
			if (currentIndex > 0) {
				currentIndex--;
				updateLightboxImage();
			}
		}

		function showNextImage() {
			if (currentIndex < items.length - 1) {
				currentIndex++;
				updateLightboxImage();
			}
		}

		function updateLightboxImage() {
			if (!lightbox) {
				return;
			}

			const img = lightbox.querySelector('.wp-block-moldovanos-block-lightbox-gallery__lightbox-image');
			const caption = lightbox.querySelector('.wp-block-moldovanos-block-lightbox-gallery__lightbox-caption');
			const prevBtn = lightbox.querySelector('.wp-block-moldovanos-block-lightbox-gallery__lightbox-nav--prev');
			const nextBtn = lightbox.querySelector('.wp-block-moldovanos-block-lightbox-gallery__lightbox-nav--next');

			const currentItem = items[currentIndex];
			const currentImg = currentItem.querySelector('img');

			// Fade out current image
			img.classList.remove('is-loaded');

			// Update image after a brief delay
			setTimeout(function() {
				img.src = currentImg.src;
				img.alt = currentImg.alt || '';

				// Show caption if exists
				const captionText = currentImg.getAttribute('data-caption') || currentImg.alt;
				if (captionText) {
					caption.textContent = captionText;
					caption.style.display = 'block';
				} else {
					caption.style.display = 'none';
				}

				// Update navigation buttons
				prevBtn.disabled = currentIndex === 0;
				nextBtn.disabled = currentIndex === items.length - 1;

				// Fade in new image when loaded
				img.onload = function() {
					img.classList.add('is-loaded');
				};
			}, 150);
		}

		function handleKeyPress(e) {
			if (!lightbox || !lightbox.classList.contains('is-open')) {
				return;
			}

			switch(e.key) {
				case 'Escape':
					closeLightbox();
					break;
				case 'ArrowLeft':
					showPrevImage();
					break;
				case 'ArrowRight':
					showNextImage();
					break;
			}
		}

		// Add click listeners to gallery items
		items.forEach(function(item, index) {
			item.addEventListener('click', function() {
				openLightbox(index);
			});
		});
	});
});
